import { observer } from 'mobx-react-lite';
import { ReactNode } from 'react';
import { FieldLabel, TFieldLabel } from '@apia/components';
import { TObjectInspection, useValidableContext, Validable } from '..';
import { getLabel } from '@apia/util';

export const ValidableField = observer(
  <T extends object>({
    children,
    context,
    label,
    path,
    ...props
  }: {
    children: ReactNode;
    context?: Validable<T>;
    label?: string;
    path: typeof context extends undefined ? string : TObjectInspection<T>;
  } & Omit<TFieldLabel, 'label' | 'error' | 'required'>) => {
    const reactContext = useValidableContext<T>();
    const actualContext = context ?? reactContext;

    if (!actualContext) throw new Error('ValidableContext not found');

    const validations = actualContext.getValidations(path);
    const error = actualContext.getError(path);
    label = label ?? validations?.fieldLabel;
    return (
      <FieldLabel
        {...props}
        error={error}
        label={
          label?.startsWith('lbl')
            ? getLabel(label).text
            : (label ?? `Label not provided: ${path}`)
        }
        required={validations?.required}
      >
        {children}
      </FieldLabel>
    );
  },
);
